import { render, staticRenderFns } from "./reason_option.vue?vue&type=template&id=791ba2ac&scoped=true"
import script from "./reason_option.vue?vue&type=script&lang=js"
export * from "./reason_option.vue?vue&type=script&lang=js"
import style0 from "./reason_option.vue?vue&type=style&index=0&id=791ba2ac&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791ba2ac",
  null
  
)

export default component.exports